import { render, staticRenderFns } from "./InventorySectorLabelGridComponent.vue?vue&type=template&id=6b133ef8"
import script from "./InventorySectorLabelGridComponent.vue?vue&type=script&lang=js"
export * from "./InventorySectorLabelGridComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports